// Configuration utilities for dynamic URLs
// Backend URL (Laravel API)
const getBackendUrl = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL || 'https://twachanga.co.ke/api';
  // Remove /api suffix to get base URL
  return apiUrl.replace(/\/api$/, '');
};

// Frontend URL (React app)
const getFrontendUrl = () => {
  return process.env.REACT_APP_FRONTEND_URL || window.location.origin;
};

export const config = {
  backendUrl: getBackendUrl(),
  frontendUrl: getFrontendUrl(),
  apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://twachanga.co.ke/api',
};

